import React, { useRef, useState, useEffect } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { Button, CircularProgress } from '@mui/material';
import {
  COURSE_THUMBNAIL_ASPECT,
  COURSE_THUMBNAIL_WIDTH,
  COURSE_THUMBNAIL_HEIGHT,
  getCroppedThumbnailFile,
} from '../../utils/courseThumbnailCrop';
import './CourseThumbnailCropper.scss';

const CourseThumbnailCropper = ({ open, imageSrc, fileName, onCancel, onConfirm }) => {
  const cropperRef = useRef(null);
  const [isApplying, setIsApplying] = useState(false);

  useEffect(() => {
    if (!open) setIsApplying(false);
  }, [open]);

  if (!open || !imageSrc) return null;

  const handleApply = async () => {
    const cropper = cropperRef.current?.cropper;
    if (!cropper) return;

    setIsApplying(true);
    try {
      const file = await getCroppedThumbnailFile(cropper, fileName);
      if (!file) return;
      onConfirm?.(file);
    } finally {
      setIsApplying(false);
    }
  };

  return (
    <div className="course-thumbnail-cropper-backdrop" onClick={onCancel}>
      <div className="course-thumbnail-cropper-modal" onClick={(e) => e.stopPropagation()}>
        <div className="course-thumbnail-cropper-header">
          <h3>Crop thumbnail</h3>
          <p>Adjust the image to fit the 16:9 display ({COURSE_THUMBNAIL_WIDTH}×{COURSE_THUMBNAIL_HEIGHT})</p>
        </div>

        <div className="course-thumbnail-cropper-body">
          <Cropper
            ref={cropperRef}
            src={imageSrc}
            style={{ height: '100%', width: '100%' }}
            aspectRatio={COURSE_THUMBNAIL_ASPECT}
            viewMode={1}
            guides
            background={false}
            responsive
            autoCropArea={1}
            checkOrientation={false}
            minCropBoxHeight={40}
            minCropBoxWidth={40}
          />
        </div>

        <div className="course-thumbnail-cropper-actions">
          <span className="course-thumbnail-cropper-tip">Scroll to zoom · Drag to reposition</span>
          <div className="course-thumbnail-cropper-buttons">
            <Button variant="outlined" onClick={onCancel} disabled={isApplying}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleApply} disabled={isApplying}>
              {isApplying ? <CircularProgress size={18} color="inherit" /> : 'Apply crop'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseThumbnailCropper;
